import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { useLang } from "../../i18n/LangContext";
import { SectionHead, useChannels } from "./Brand";

export const Faq = () => {
  const { faq: t } = useLang().t;
  const CHANNELS = useChannels();
  return (
  <section id="faq" className="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8">
    <div className="grid gap-16 lg:grid-cols-5">
      <div className="lg:col-span-2">
        <SectionHead eyebrow={t.eyebrow} title={t.title} sub={t.sub} />
        <div className="flex flex-col gap-3">
          {CHANNELS.map((c) => (
            <a key={c.key} href={c.href} target="_blank" rel="noreferrer" data-testid={`faq-${c.key}-link`}
              className="glass-card flex items-center gap-4 p-4 transition-colors hover:border-[#D4AF37]">
              <c.icon style={{ color: c.color }} size={20} />
              <span className="text-sm text-white">{t.chatOn} {c.label}</span>
            </a>
          ))}
        </div>
      </div>
      <Accordion type="single" collapsible className="lg:col-span-3" data-testid="faq-accordion">
        {t.items.map((f, i) => (
          <AccordionItem key={i} value={`i${i}`} className="border-[#D4AF37]/20">
            <AccordionTrigger data-testid={`faq-accordion-item-${i}`} className="py-6 text-left font-serif text-lg text-white hover:text-[#D4AF37] hover:no-underline">{f.q}</AccordionTrigger>
            <AccordionContent className="text-base leading-relaxed text-zinc-400">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
  );
};
